import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EntryIcon } from "../../../ui/icons/entryIcon"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { formatterDate } from "../../../utils"
import { resetUpdateProforma, setIncProformaToView } from "../../incarichi/inspectionVisit/edit/gestioneRimborsi/slice"
import { PopupProforma } from "./popupProforma"

export function AssignmentsListReport() {

    const dispatch = useAppDispatch()
    const PersonaleContabile = useAppSelector(state => state.PersonaleContabile)
    const assignments = PersonaleContabile.GetAllPersonaleContabileResponse ?? []
    const [showEditAssignment, setShowEditAssignment] = useState<boolean>(false)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const reimbursement = useAppSelector(state => state.reimbursement)

    useEffect(() => {
        if (reimbursement.updateProformaRequestStatus === 'successfully') {
            setShowEditAssignment(false)
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500)
            dispatch(resetUpdateProforma())
        }
    }, [reimbursement.updateProformaRequestStatus])

    return (
        <div className="p-6">
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Operazioni</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Codice Identificativo</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Riferimento</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Incarico</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo Contratto</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Proforma</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Validata</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Importo (Lordo)</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Rimborso Km</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Rimborso Spese Viaggio</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Rimborso Spese Postali</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Rimborso Spese Pedaggio</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">N Fattura</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Fattura</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Fattura</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Visualizza Proforma</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assignments.length === 0 ? (
                            <tr>
                                <td colSpan={16} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                    Nessun risultato
                                </td>
                            </tr>
                        ) : (
                            assignments.map((ass, index) => (
                                <tr
                                    key={index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        <div className="flex items-center justify-center gap-2">
                                            <button
                                                onClick={() => {
                                                    dispatch(setIncProformaToView(ass.proformaId))
                                                    // dispatch(setIncProformaToView('80'))
                                                    setShowEditAssignment(true);
                                                }}
                                                className="tooltip-container p-1 rounded hover:bg-neutral-100 transition-colors"
                                            >
                                                <EntryIcon color={"orange"} size={28} />
                                                <span className="tooltip-text">Apri Incarico</span>
                                            </button>
                                        </div>
                                    </td>

                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.inspectorCode}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.reference}</td>

                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.assignmentProtocolInfo}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">TBD</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(ass.proformaCreationDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.grossAmount}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.kmReimbursement}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.travelCosts}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.postalCosts}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.pedaggioCosts}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.invoiceNumber}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(ass.invoiceDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.invoiceProtocolInfo}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                </tr>
                            )))}
                    </tbody>
                </table>
            </div>
            {
                showEditAssignment && (
                    <PopupForm headerGreen={true} title={'Modifica Proforma'} close={() => {
                        setShowEditAssignment(false)
                    }}>
                        <div>
                            <PopupProforma />
                        </div>
                    </PopupForm>
                )
            }
        </div>
    )
}